export type LandingVisualKey = 'dashboard' | 'quotes' | 'gallery' | 'invoices' | 'ai-agents';

export interface LandingVisual {
  key: LandingVisualKey;
}

/**
 * MKT-001 — which of the product's five faces a section is about.
 *
 * This used to name a screenshot as well. The page carries no pictures now: the
 * words do the selling, and a marketing page whose middle is six screenshots of
 * a product nobody has logged into yet is showing furniture, not making a case.
 * What is left of it is the key, which still picks the section's glyph and the
 * one layout modifier the AI section gets.
 */
const VISUALS: Record<string, LandingVisualKey> = {
  'landing.sections.hero': 'dashboard',
  'landing.sections.quotes': 'quotes',
  'landing.sections.tracking': 'quotes',
  'landing.sections.portfolio': 'gallery',
  'landing.sections.invoices': 'invoices',
  'landing.sections.ai': 'ai-agents',
};

export function landingVisualFor(contentKey: string | null): LandingVisual | null {
  if (!contentKey) return null;
  const key = VISUALS[contentKey];
  return key ? { key } : null;
}
